'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

import 'rangeslider.js';

// ----------------------------------------
// Private
// ----------------------------------------
let $rangeSlider = $('.range-slider');
let $calculator = $('.calculator');
let $rangeEl;
let month = 30;
let year = 365;
let gasPrice = $calculator.data('gas');
let kbtPrice = $calculator.data('electro');
let	stoPrice = $calculator.data('sto');
let	$totalLitresOutput = $('.total-litres');
let $gasPriceOutput = $('.gas-price');
let $gasTotalOutput = $('.gas-total');
let $kbtPriceOutput = $('.kbt-price');
let $electroPriceOutput = $('.electro-price');
let $electroTotalOutput = $('.electro-total');
let $stoPriceOutput = $('.sto-price');
let $stoTotalOutput = $('.sto-total');
let $gasCostOutput = $('.gas-cost');
let $electroCostOutput = $('.electro-cost');
let $yearTotalOutput = $('.year-total');
let $monthTotalOutput = $('.month-total');
let $totalProfitOutput = $('.economy-main');
let monthTotal;
let yearTotal;
let totalLitres;
let gasTotal;
let stoTotal;
let gasCost;
let electroPrice;
let electroTotal;
let electroCost;
let totalProfit;

// Thousand separator

function setThousands (numberText, newSeparator, separator) {
	newSeparator = newSeparator || '.';
	separator = separator || '.';
	numberText = '' + numberText;
	numberText = numberText.split(separator);

	var numberPenny = numberText[1] || '';
	var numberValue = numberText[0];

	var thousandsValue = [];
	var counter = 0;

	for (var i = numberValue.length - 1; i >= 0; i--) {
		var num = numberValue[i];
		thousandsValue.push(num);

		if (++counter === 3 && i) {
			thousandsValue.push(' ');
			counter = 0;
		}
	}

	thousandsValue = thousandsValue.reverse().join('');
	if (numberPenny.length) {
		return [thousandsValue, numberPenny].join(newSeparator);
	}
	return thousandsValue;
}

function cost (value) {
	// calculate the values

	monthTotal = value * month;
	yearTotal = value * year;
	totalLitres = Math.floor(yearTotal / 10);
	gasTotal = totalLitres * gasPrice;
	stoTotal = stoPrice * 2;
	gasCost = gasTotal + stoTotal;
	electroPrice = (8 * 3) * kbtPrice;
	electroTotal = electroPrice / 150;
	electroCost = Math.floor(yearTotal * electroTotal);
	totalProfit = gasCost - electroCost;

	// append values on the page

	$yearTotalOutput.text(setThousands(yearTotal));
	$monthTotalOutput.text(setThousands(monthTotal));
	$totalLitresOutput.text(setThousands(totalLitres));
	$gasTotalOutput.text(setThousands(gasTotal));
	$stoTotalOutput.text(setThousands(stoTotal));
	$gasCostOutput.text(setThousands(gasCost));
	$electroPriceOutput.text(electroPrice.toFixed(2));
	$electroTotalOutput.text(electroTotal.toFixed(2));
	$electroCostOutput.text(setThousands(electroCost));
	$totalProfitOutput.text(setThousands(totalProfit));
}

// ----------------------------------------
// Public
// ----------------------------------------

function profitCalculator () {
	if (!$calculator.length) {
		return false;
	}

	$gasPriceOutput.text(gasPrice);
	$stoPriceOutput.text(setThousands(stoPrice));
	$kbtPriceOutput.text(kbtPrice);

	let value = $rangeSlider.val();

	cost(value);

	$rangeSlider.rangeslider({
		polyfill: false,

		onInit: function () {
			$rangeEl = this.$range;

			let $handle = $rangeEl.find('.rangeslider__handle');
			let handleValue = `<div class='rangeslider__handle-value'>` + (this.value + ' км') + `</div>`;

			$handle.append(handleValue);
		},

		onSlide: function (position, value) {
			let $handle = this.$range.find('.rangeslider__handle-value');
			$handle.text(this.value + ' км');

			cost(value);
		}

	});
}

function calculator () {

}

// ----------------------------------------
// Exports
// ----------------------------------------

export {profitCalculator, calculator};



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/profit-calculator.js